import * as React from 'react';
import AvatarEditor from 'react-avatar-editor';

import Button from 'components/ButtonDeprecated';
import Dialog from 'components/Dialog';
import Slider from 'components/Slider';

import './styles/AvatarEditorModal.scss';

const DIAMETER_PIXELS = 350;
const TRANSPARENT_WHITE_COLOR = [255, 255, 255, 0.5];
const INITIAL_SCALE = 1.2;

type Props = {
  image: string;
  filename: string;
  onRequestHide?: () => void;
  onSave: (file: File) => void;
};

type State = {
  scale: number;
};

class AvatarEditorModal extends React.Component<Props, State> {
  state: State = {
    scale: INITIAL_SCALE,
  };
  _editor: AvatarEditor | null = null;

  handleSave = () => {
    const { filename, onSave, onRequestHide } = this.props;

    if (!this._editor) {
      console.error('AvatarEditorModal allowed upload without editor');
      return;
    }

    const scaledCanvas: HTMLCanvasElement = this._editor.getImageScaledToCanvas();
    scaledCanvas.toBlob((blob: Blob | null) => {
      if (blob) {
        (blob as any).name = filename; // add back the original name before uploading
        onSave(blob as File);
      }

      if (onRequestHide) {
        onRequestHide();
      }
    });
  };

  updateImageScale = (value: number) => {
    this.setState({ scale: value });
  };

  render() {
    const { image, onRequestHide } = this.props;
    const { scale } = this.state;

    return (
      <Dialog
        className="AvatarEditorModal"
        eventScreenName="AvatarEditorModal"
        size="small"
        onRequestHide={onRequestHide}
        hideOnBlur={false}>
        <AvatarEditor
          ref={editor => (this._editor = editor)}
          image={image}
          width={DIAMETER_PIXELS}
          height={DIAMETER_PIXELS}
          borderRadius={DIAMETER_PIXELS / 2}
          color={TRANSPARENT_WHITE_COLOR}
          scale={scale}
          style={{ 'margin-top': ' 16px' }} // styles are passed to canvas element
        />
        <div className="AvatarEditorModal-controls">
          <Slider
            className="AvatarEditorModal-controls-slider"
            min={1}
            max={2.5}
            step={0.01}
            value={scale}
            onChange={this.updateImageScale}
            theme="light"
            size="thick"
          />
          <Button
            className="AvatarEditorModal-controls-saveButton"
            onClick={this.handleSave}>
            Save
          </Button>
        </div>
      </Dialog>
    );
  }
}

export default AvatarEditorModal;
